// extracted by mini-css-extract-plugin
export var container = "ElevatedWithBlurBackGround-module--container--16Rnz";